// extracted by mini-css-extract-plugin
export default {"active":"CustomLink_active__X83eK"};